const isFileInvalid = (file) => {
  const fileType = file.type.split('/').at(-1);
  const fileSizeMb = Number((file.size/1024/1024).toFixed(1));
  return (fileType !== 'jpeg' && fileType !== 'pdf') || fileSizeMb > 30;
}

export default isFileInvalid;